import { useContext } from "react";

import Context from "../context";
import CustomTextInput from "./CustomTextInput";
import TextInputField from "./TextInputField";

// ----------------------------------------------------------------------

type Props = {
	label?: string;
	type?: string;
	name: string;
};

export const DTextInput = ({ name, label, type = "text" }: Props) => {
	const { customConnectProps } = useContext(Context);

	const hasTheme = !!customConnectProps?.theme;

	return hasTheme ? (
		<CustomTextInput label={label ?? ""} type={type} name={name} />
	) : (
		<TextInputField label={label ?? ""} type={type} name={name} />
	);
};

export default DTextInput;
